export default {"beams":"fY415"};